// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwNavigateBreadcrumb from 'viewmodel/AwNavigateBreadcrumbViewModel';
import AwScrollpanel from 'viewmodel/AwScrollpanelViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": ["js/aw-splm-table.directive"],
  "actions": {
    "listProjectContentsAsTreedataProviderMethod": {
      "actionType": "dataProvider",
      "method": "projectContentsDataProvider"
    },
    "loadData": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getProjectContents( $projectId: String, $collaborationspaceId: String, $folderId: String, $skip: Int, $filterString: String, $totalCount: Int) { getProjectContents( projectId: $projectId, collaborationspaceId: $collaborationspaceId, folderId: $folderId, skip: $skip, filterString: $filterString, totalCount: $totalCount ) { error items totalCount skip }}",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "folderId": "{{eventData.folderUid}}",
              "projectId": "{{props.projectid}}",
              "filterString": "",
              "skip": "{{data.projectContentsSkip}}",
              "totalCount": "{{data.totalCount}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "projectContents",
        "responseObjs": "data.data.getProjectContents.items"
      }],
      "outputData": {
        "errorCode": "errorCode",
        "getProjectContents": "data.data.getProjectContents",
        "projectContents": "data.data.getProjectContents.items",
        "projectContentsSkip": "data.data.getProjectContents.skip",
        "totalCount": "data.data.getProjectContents.totalCount"
      },
      "events": {
        "success": [{
          "name": "loadData.noDataFound",
          "condition": "conditions.noDataFoundForTable"
        }],
        "failure": []
      },
      "actionMessages": {},
      "deps": "js/accHttpService"
    },
    "createCrumb": {
      "actionType": "JSFunction",
      "method": "createBreadCrumb",
      "inputData": {
        "data": "{{data}}",
        "selectedObjects": "{{data.eventData}}"
      },
      "deps": "js/desSearchService"
    },
    "openFolder": {
      "actionType": "JSFunction",
      "method": "openFolder",
      "inputData": {
        "data": "{{data}}"
      },
      "deps": "js/desSearchService"
    },
    "openBreadcrumbFolder": {
      "actionType": "JSFunction",
      "method": "openBreadcrumbFolder",
      "inputData": {
        "data": "{{data}}",
        "selectedCrumb": "{{data.eventData.selectedCrumb}}",
        "crumbIndex": "{{data.eventData.crumbIndex}}"
      },
      "deps": "js/desSearchService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "publishEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventId": "{{parameters.eventId}}"
      },
      "deps": "js/desSearchService"
    },
    "batchJobActionOnUpdate": {
      "actionType": "batchJob",
      "steps": [{
        "action": "resetSkipValue"
      }, {
        "action": "listProjectContentsAsTreedataProviderMethod"
      }, {
        "action": "onMountBreadcrumbList"
      }]
    },
    "resetSkipValue": {
      "actionType": "JSFunction",
      "method": "resetSkipValue",
      "inputData": {
        "vmo": "{{data}}"
      },
      "outputData": {},
      "deps": "js/desSearchService"
    },
    "clearBreadcrumb": {
      "actionType": "JSFunction",
      "method": "clearBreadcrumb",
      "inputData": {
        "data": "{{data}}"
      },
      "deps": "js/desSearchService"
    },
    "onMountBreadcrumbList": {
      "actionType": "JSFunction",
      "method": "onMountBreadcrumbListFunction",
      "deps": "js/desSearchService"
    },
    "handleIxBrandingBreadcrumb": {
      "actionType": "JSFunction",
      "method": "handleIxBrandingBreadcrumbLinkFunction",
      "deps": "js/desSearchService"
    },
    "batchJobActionOnOpenFolderSuccess": {
      "actionType": "batchJob",
      "steps": [{
        "action": "publishToACCEventBus"
      }, {
        "action": "handleIxBrandingBreadcrumb"
      }]
    }
  },
  "data": {
    "dynamicCrumbs": [{
      "clicked": false,
      "displayName": "Project",
      "selectedCrumb": true,
      "showArrow": true,
      "cellType": "Project"
    }],
    "projectContentsSkip": 0,
    "folderUids": [],
    "crumbsData": []
  },
  "dataParseDefinitions": {
    "projectContents": {
      "containerId": "{{response.containerId}}",
      "identifier": "{{response.relUID}}",
      "typeIconURL": "{{response.typeIconURL}}",
      "name": "{{response.name}}",
      "typeName": "{{response.cellType}}",
      "props": {
        "name": {
          "name": "name",
          "displayName": "Name",
          "value": "{{response.name}}",
          "displayValue": "{{response.name}}",
          "type": "STRING"
        },
        "typeName": {
          "name": "typeName",
          "displayName": "Type",
          "value": "{{response.cellType}}",
          "displayValue": "{{response.cellType}}",
          "type": "STRING"
        },
        "description": {
          "name": "description",
          "displayName": "Type",
          "value": "{{response.description}}",
          "displayValue": "{{response.description}}",
          "type": "STRING"
        }
      }
    }
  },
  "dataProviders": {
    "projectContentsDataProvider": {
      "action": "loadData",
      "response": "{{data.projectContents}}",
      "totalFound": "{{data.totalCount}}",
      "selectionModelMode": "single",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "projectContentsColumnProvider": {
      "frozenColumnIndex": -1,
      "columns": [{
        "name": "name",
        "displayName": "{{i18n.name}}",
        "minWidth": 150,
        "width": 300,
        "enableColumnMenu": false
      }, {
        "name": "typeName",
        "displayName": "{{i18n.typeName}}",
        "minWidth": 150,
        "width": 250,
        "enableColumnMenu": false
      }]
    }
  },
  "grids": {
    "navigateProjectContentTable": {
      "dataProvider": "projectContentsDataProvider",
      "columnProvider": "projectContentsColumnProvider",
      "addIconColumn": false,
      "gridOptions": {
        "enablePinning": false,
        "enableSorting": false,
        "isFilteringEnabled": false,
        "enableGridMenu": false,
        "rowHeight": "LARGE",
        "enableDynamicRowHeight": true
      }
    }
  },
  "i18n": {
    "actions": ["projectMessages"],
    "name": ["projectMessages"],
    "typeName": ["projectMessages"],
    "description": ["projectMessages"]
  },
  "lifecycleHooks": {
    "onMount": "fetchProjectContentsAsTree",
    "onUnmount": "clearBreadcrumb",
    "onUpdate": [{
      "action": "batchJobActionOnUpdate",
      "observers": ["props.accsessionid", "props.collaborationspaceid", "props.projectid", "props.folderid", "props.ix-enabled"]
    }]
  },
  "onEvent": [{
    "eventId": "fetchProjectContentsAsTree",
    "action": "listProjectContentsAsTreedataProviderMethod",
    "cacheEventData": true
  }, {
    "eventId": "openFolder",
    "action": "openFolder",
    "cacheEventData": true
  }, {
    "eventId": "openFolder",
    "action": "createCrumb",
    "cacheEventData": true
  }, {
    "eventId": "openBreadcrumbFolder",
    "action": "openBreadcrumbFolder",
    "cacheEventData": true
  }, {
    "eventId": "projectContentsDataProvider.selectionChangeEvent",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-table.selected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "openFolderSuccess",
    "action": "batchJobActionOnOpenFolderSuccess",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-table.navigate",
      "eventData": "{{eventData}}"
    }
  }, {
    "eventId": "loadData.noDataFound",
    "action": "publishEvent",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-table.data-not-available"
    }
  }],
  "props": {
    "collaborationspaceid": {
      "type": "string"
    },
    "accsessionid": {
      "type": "string"
    },
    "projectid": {
      "type": "string"
    },
    "ix-enabled": {
      "type": "boolean"
    }
  },
  "conditions": {
    "noDataFoundForTable": {
      "expression": "data.dataProviders.projectContentsDataProvider.vmCollectionObj.dataLoaded && data.totalCount === 0"
    }
  },
  "_viewModelId": "NavigateProjectContentsAsTable",
  "_uniqueViewModelId": "NavigateProjectContentsAsTable",
  "ctx": {}
};

/*
<div id="navigatebreadcrumbdiv">
    <aw-flex-row height="2.5f">
        <aw-navigate-breadcrumb crumbs="data.dynamicCrumbs"></aw-navigate-breadcrumb>
    </aw-flex-row>
</div>
<div id="navigatetablediv">
    <aw-scrollpanel class="aw-layout-full h-12">
        <aw-splm-table gridid="navigateProjectContentTable"></aw-splm-table>
    </aw-scrollpanel>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "navigatebreadcrumbdiv"
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "2.5f"
  }, /*#__PURE__*/React.createElement(AwNavigateBreadcrumb, {
    crumbs: AwParseService.instance("data.dynamicCrumbs")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))), /*#__PURE__*/React.createElement("div", {
    id: "navigatetablediv"
  }, /*#__PURE__*/React.createElement(AwScrollpanel, {
    className: "aw-layout-full h-12"
  }, /*#__PURE__*/React.createElement(AwSplmTable, grids.navigateProjectContentTable))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;